export type AccountAccess = 'full' | 'places_preview'

export function isPlacesPreviewOnly(
  access: AccountAccess | null | undefined,
): boolean {
  return access === 'places_preview'
}
